// extracted by mini-css-extract-plugin
export default {"panelMeta":"PanelMeta_panelMeta__ZQmrJ","panelMeta__block":"PanelMeta_panelMeta__block__sqFYo","panelMeta__howToOrder":"PanelMeta_panelMeta__howToOrder__Lg7pF"};